import { getPrecedingSession, getSessionByAppointmentId, getSessionClinicalNotes } from '@uplift/api';
import { useCallback } from 'react';

export const useSession = () => {

  const fetchSession = useCallback(async (appointmentId: string) => {
    try {
      const sessionResponse = await getSessionByAppointmentId(appointmentId);
      const clinicalNoteResponse = await getSessionClinicalNotes(sessionResponse.data.id);

      return clinicalNoteResponse.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }, []);

  return { fetchSession };
};

export const usePreviousSession = () => {

  const fetchPreviousSession = useCallback(async (sessionId: string) => {
    try {
      const res = await getPrecedingSession(sessionId);

      return res.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }, []);

  return { fetchPreviousSession };
};
